import {
  Button, DashboardModuleListItem, Form, Image, SidebarModal,
} from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'

import { useSetState } from '@domain-group/react-hooks'

import EntitySelector from '@components/EntitySelector'

import type { CampaignModel } from '@models/types'

import useAgencyMarketingCampaign from '../../hooks/useAgencyMarketingCampaign'
import placeholderImageUrl from '../../assets/campaign_image_400x400.png'

type DefaultState = {
  marketingType: 'agency_marketing' | 'property_marketing' | string,
  selectedCampaignId: number | null,
}

const defaultState: DefaultState = {
  marketingType: 'agency_marketing',
  selectedCampaignId: null,
}

interface ExistingCampaignProps {
  agencyMarketingCampaignParams: {
    categoryId: number,
    selectedAgencyId: number,
    selectedProviderPriceListItemId: number,
    selectedProviderPriceListItemOptions: number,
    selectedTemplatePageId: number,
  },
  callbacks: {
    closeModal: () => void,
    createArtworkWithCampaign: (payload: HandleCallbackActionParams) => void,
  },
}

const ExistingCampaign = (props: ExistingCampaignProps) => {
  const {
    agencyMarketingCampaignParams,
    callbacks: { createArtworkWithCampaign },
  } = props

  const [state, setState] = useSetState(defaultState)
  const { marketingType, selectedCampaignId } = state

  const agencyMarketingCampaignPayload = useAgencyMarketingCampaign({
    ...agencyMarketingCampaignParams,
    selectedCampaignId,
  })

  const {
    agencyMarketingPayload,
    callbacks: {
      createArtworkWithCampaign: createFn,
    },
    campaignPayload,
    creatingArtwork,
    selectedAgencyId,
  } = agencyMarketingCampaignPayload

  const { campaign } = campaignPayload || {}

  const {
    address,
    default_image,
    suburb_name,
  } = campaign || {}

  const createPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: {
      ...agencyMarketingPayload,
      campaign: {
        id: selectedCampaignId,
      },
    },
    shouldRedirect: true,
    toastText: 'Order Created',
  }

  return (
    <>
      <SidebarModal.Content>
        <Form>
          <Form.Field direction="column" label="Campaign Type">
            <select
              name="marketingType"
              onChange={e => setState({ marketingType: e.target.value })}
              value={marketingType}
            >
              <option value="agency_marketing">Agency Marketing</option>
              <option value="property_marketing">Property Marketing</option>
            </select>
          </Form.Field>

          <EntitySelector
            callbacks={{
              // @ts-expect-error TS2322
              selectItem: (selectedCampaign: CampaignModel) => setState({ selectedCampaignId: selectedCampaign.id }),
            }}
            entityKey="campaigns"
            label="* Campaign Search"
            marginTop="large"
            requestOptions={{
              agency_id: selectedAgencyId,
              include_campaign_image: true,
              use_campaign_first_image: true,
            }}
            showSelectedEntity={false}
            searchRequestOptions={{
              agency_marketing: marketingType === 'agency_marketing',
              limit: 10,
            }}
            // @ts-expect-error TS2322
            selectedItemId={selectedCampaignId}
          />

          {!!selectedCampaignId && (
            <Form.Field
              direction="column"
              label="Selected Campaign"
              marginTop="large"
            >
              <DashboardModuleListItem
                boxProps={{ padding: 0 }}
                imageComponent={(
                  <Image
                    backgroundSize="cover"
                    borderRadius={5}
                    boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
                    placeholderUrl={placeholderImageUrl}
                    url={default_image}
                  />
                )}
                title={address}
                secondaryText={suburb_name}
              >
                {/*
                 // @ts-expect-error TS2339 */}
                <DashboardModuleListItem.Actions>
                  {/*
                   // @ts-expect-error TS2339 */}
                  <DashboardModuleListItem.Icon
                    onClick={() => setState({ selectedCampaignId: null })}
                    type="delete"
                  />
                  {/*
                 // @ts-expect-error TS2339 */}
                </DashboardModuleListItem.Actions>
              </DashboardModuleListItem>
            </Form.Field>
          )}
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!selectedCampaignId}
          loading={creatingArtwork}
          // @ts-expect-error TS2345
          onClick={() => createArtworkWithCampaign(createPayload)}
          size="large"
        >
          {selectedCampaignId ? 'Add to Campaign' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </>
  )
}

export default ExistingCampaign
